import { createStyles, getStylesRef, rem } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {
      display: 'block',
      textDecoration: 'none',
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        opacity: 0,
        backgroundImage:
          'radial-gradient(50% 100% at 50% 0%, #E3F2FF 0%, #FFFFFF 100%)',
        transition: 'opacity 0.3s ease',
      },
      '&:hover': {
        '&:before': {
          opacity: 1,
        },
        [`.${getStylesRef('btn')}`]: {
          borderColor: theme.fn.primaryColor(),
        },
      },
    },
    inner: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      gap: 24,
      justifyContent: 'space-between',
      padding: `${rem(12)} 0`,
      [theme.fn.largerThan('sm')]: {
        padding: `${rem(16)} 0`,
      },
    },
    body: {
      display: 'flex',
      alignItems: 'center',
      gap: 12,
      [theme.fn.largerThan('sm')]: {
        gap: 24,
      },
    },
    thumbnail: {
      width: 40,
      flexShrink: 0,
      [theme.fn.largerThan('sm')]: {
        width: 48,
      },
    },
    info: {
      display: 'flex',
      flexDirection: 'column',
      gap: 4,
    },
    desc: {
      [theme.fn.smallerThan('sm')]: {
        display: 'none',
      },
    },
    btn: {
      ref: getStylesRef('btn'),
      fontWeight: 'normal',
      color: theme.fn.primaryColor(),
      paddingRight: 12,
    },
    action: {},
  }
})
